import { barHeight } from './scale';

export type BarChartProps = {
  data: { label: string; value: number }[];
  /** Rótulo acima da barra; valor 0 mostra "–". */
  format?: (v: number) => string;
  /** Altura da maior barra em px. */
  barMaxHeight?: number;
  /** Descrição acessível. No mobile o CSS do pacote mostra só as 8 primeiras colunas. */
  label: string;
};

/** Colunas (`.cols`), ex.: comprometido por mês nas parcelas. */
export function BarChart({ data, format = (v) => String(v), barMaxHeight = 150, label }: BarChartProps) {
  const max = Math.max(0, ...data.map((d) => d.value));
  return (
    <div className="cols" role="img" aria-label={label}>
      {data.map((d) => (
        <div key={d.label}><b>{d.value ? format(d.value) : '–'}</b><i style={{ height: `${barHeight(d.value, max, barMaxHeight)}px` }} /><span>{d.label}</span></div>
      ))}
    </div>
  );
}
